import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private readonly _commonInfo = new BehaviorSubject<any | null>(null);

  get getCommonInfoValue() {
    return this._commonInfo.value;
  }

  get getCommonInfo$() {
    return this._commonInfo.asObservable();
  }
  set setCommonInfo(info: object) {
    this._commonInfo.next({ ...this._commonInfo.value, ...info });
  }
}
